import { Check, Plus } from 'lucide-react'
import type {
  ShortVideoChannel,
  ShortVideoSubscribe,
} from '@services/firebase/short-videos'
import { LmsButton } from '@shared/ui'

export function ShortVideoChannelCard({
  channel,
  compact = false,
  onToggleSubscribe,
  subscribed,
  subscribeCount,
}: {
  readonly channel: ShortVideoChannel
  readonly compact?: boolean
  readonly onToggleSubscribe: () => void
  readonly subscribed: ShortVideoSubscribe | null
  readonly subscribeCount: number
}) {
  return (
    <article className={`shortVideoChannelCard ${compact ? 'isCompact' : ''}`}>
      <div className="shortVideoChannelContent">
        <span className="shortVideoChannelImage">
          <img
            alt={channel.title ?? 'Channel'}
            className="shortVideoChannelAvatar"
            src={channel.featuredImage || '/images/no-image.jpg'}
          />
        </span>
        <span className="shortVideoChannelTitle">{channel.title ?? 'Channel'}</span>
        <span className="shortVideoChannelMeta">{subscribeCount} subscribers</span>
        <LmsButton
          aria-pressed={Boolean(subscribed)}
          className={`shortVideoSubscribeButton ${subscribed ? 'isSubscribed' : ''}`}
          leadingIcon={subscribed ? <Check aria-hidden="true" /> : <Plus aria-hidden="true" />}
          onClick={onToggleSubscribe}
          variant={subscribed ? 'secondary' : 'outline'}
        >
          {subscribed ? 'Unsubscribe' : 'Subscribe'}
        </LmsButton>
      </div>
    </article>
  )
}
